import React from "react";
import classNames from "classnames";
import { useNavigate } from "react-router-dom";

import { DropBox } from "@common/dragAndDrop";
import { useMoveDocument } from "@planzone/view-models";
import { Props } from "./types";
import styles from "./styles.scss";

function Path({ path, project, onNavigate, className = "" }: Props) {
  const push = useNavigate();
  const { moveDocument } = useMoveDocument();

  return (
    <ul className={classNames(className, styles.path)}>
      {path.map(({ uuid, name }, index) => (
        <li
          key={uuid}
          className={classNames(styles.item, {
            [styles.project]: index === 0,
          })}
          onClick={() =>
            !!onNavigate
              ? onNavigate(project.uuid, uuid)
              : push(`/projects/${project.uuid}/documents/folders/${uuid}`)
          }
        >
          <DropBox
            acceptedTypes={["MOVE_DOCUMENT"]}
            drop={(data) =>
              moveDocument({
                document: data.payload,
                from: data.payload.parentUuid,
                to: uuid,
              })
            }
          >
            {(data, canDrop) => (
              <p className={classNames({ [styles.dropZone]: canDrop })}>
                {index === 0 ? project.name : name}
              </p>
            )}
          </DropBox>
        </li>
      ))}
    </ul>
  );
}

export { Path };
